import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Form, Button } from 'react-bootstrap'

// import WarningModal from '../../../components/WarningModal'

import { usePrevious } from '../../../hooks/usePrevious'

import PathogenSelectionOption from './PathogenSelectionOption'
import CustomCheckboxOptionModal from './CustomCheckboxOptionModal'

import { setCustomPathogenWarning } from '../reducers/infectionCourseFormReducer'

const PathogenSelection = (props) => {

  const [showCustomOptionModal, setShowCustomOptionModal] = useState(false)
  const [pathogenToPatch, setPathogenToPatch] = useState(null)

  const previouslySaving = usePrevious(props.disabled)
  
  const checkIfSaveIsComplete = () => {
    const saving = props.disabled
    if (showCustomOptionModal && saving === false && previouslySaving === true && !props.showWarning && !props.warningMessage) {
      setShowCustomOptionModal(false)
      setPathogenToPatch(null)
    }
    
  }

  useEffect(checkIfSaveIsComplete)


  const handleUpdateNestedFieldViaModal = (pathogen) => {
    setPathogenToPatch(pathogen)
    setShowCustomOptionModal(true)
  }

  const handleOnConfirm = (pathogenDescription) => {
    handlePathogenSelect('Other', true, site, null, pathogenDescription)
  }

  const handleOnConfirmPatch = (updatedName) => {
    const updatedPathogen = {
      ...pathogenToPatch,
      other_pathogen_description: updatedName,
    }
    return props.handlePathogenBlur(props.site, updatedPathogen)
  }

  const handleCancel = () => {
    setShowCustomOptionModal(false)
    setPathogenToPatch(null)
  }

  const {
    site,
    handlePathogenSelect,
    chartForReview,
  } = props

  const getRequired = (options) => {
    if (options.length !== 0) {
      let required = true
      if (site.pathogens.length !== 0) {
        required = false
      }
      return required
    } else {
      return null
    }
  }

  const getValue = (option, fieldName) => {
    //because of nested nature of primaryInfectionSites, this function returns the value of the input
    const existingPathogen = props.site.pathogens.find(pathogen => {
      if (option.id) {  
        return pathogen.id === option.id
      } else {
        return pathogen.name === option.displayName
      }
    })
    let nestedName
    if (fieldName) {
      nestedName = fieldName
    } else {
      nestedName = option.nestedName
    }
    return existingPathogen[`${nestedName}`]
  }

  const pathogenOptions = [
    {displayName: 'acinetobacter baumannii',
    fieldName: 'acinetobacterBaumannii',
    selectFields: [
      {displayName: 'Colony Count >105/ml?',
      fieldName: 'acinetobacter baumannii'}
    ]},
    {displayName: 'pseudomonas aeruginosa',
    fieldName: 'pseudomonasAeruginosa',
    selectFields: [
      {displayName: 'Colony Count >105/ml?',
      fieldName: 'pseudomonas aeruginosa'}
    ]},
    {displayName: 'stenotrophomonas maltophilia',
    fieldName: 'stenotrophomonasMaltophilia',
    selectFields: [
      {displayName: 'Colony Count >105/ml?',
      fieldName: 'stenotrophomonas maltophilia'}
    ]},
    {displayName: 'klebsiella pneumoniae',
    fieldName: 'klebsiellaPneumoniae',
    selectFields: [
      {displayName: 'Colony Count >105/ml?',
      fieldName: 'klebsiella pneumoniae'}
    ]},
    {displayName: 'escherichia coli',
    fieldName: 'escherichiaColi',
    selectFields: [
      {displayName: 'Colony Count >105/ml?',
      fieldName: 'escherichia coli'}
    ]},
    {displayName: 'achromobacter spp.',
    fieldName: 'achromobacterSpp',
    selectFields: [
      {displayName: 'Colony Count >105/ml?',
      fieldName: 'achromobacter spp.'}
    ]},
    {displayName: 'burkholderia cepacia complex',
    fieldName: 'burkholderiaCepaciaComplex',
    selectFields: [
      {displayName: 'Colony Count >105/ml?',
      fieldName: 'burkholderia cepacia complex'}
    ]},
  ]

  let pathogenOtherSelections = []

  if (Array.isArray(site.pathogens)) {
    pathogenOtherSelections = site.pathogens.filter((site) => {
      return site.name.toLowerCase() === 'other'
    })
  }

  // const checkCustomFieldsBeforeSavingPathogens = () => {
  //   if (!site.displayPathogenQuestions) {
  //     const incompleteCustomFields = pathogenOtherSelections.filter(site => {
  //       return !site.other_pathogen_description
  //     })
  
  //     if (incompleteCustomFields.length > 0) {
  //       return props.setCustomPathogenWarning('Warning: Please enter a name for all custom pathogens. If you wish to remove the custom pathogen, click the checkbox next to it.')
  //     }
  //   }

  //   return props.handleSavePathogensClick()
  // }

  let pathogenIdAndName = ''

  if (props.site && props.site.id) {
    pathogenIdAndName = `${site.infection_site}-${site.id}`
  }

  return (
    <div className="">
      <Row>
        <Col xs={12} sm={12} md={10} lg={10}>
          <Form.Label>
            Pathogen(s) identified
          </Form.Label>
          <Form.Text>
            Select all that apply, then click "Save Pathogens" button. To delete a pathogen, simply uncheck the box next to it.
          </Form.Text>
          <Form.Text style={{ marginBottom: '15px' }}>
            If you need to enter a pathogen that is not in the list below, click the "Add Other Pathogen" button and enter the pathogen's name when prompted.
          </Form.Text>
        </Col>
      </Row>

      {/* <WarningModal
        show={props.showWarning}
        onHide={() => props.setCustomPathogenWarning('')}
        onConfirm={() => props.setCustomPathogenWarning('')}
        headerText="Custom Pathogen Error"
        bodyText={props.warningMessage}
        confirmText="OK"
        hideCancelButton
      /> */}

      {pathogenOptions.map(option => {
        const selectedPathogen = site.pathogens.find(pathogen => pathogen.name.toLowerCase() === option.displayName.toLowerCase())
        const optionIsSelected = !!selectedPathogen

        return (
          <PathogenSelectionOption 
            key={`pathogen-selection-option-${pathogenIdAndName}-${option.displayName}`}
            option={option}
            pathogen={selectedPathogen}
            optionIsSelected={optionIsSelected}
            site={site}
            disabled={props.disabled}
            primary_infection_sites={props.primary_infection_sites}
            required={getRequired(pathogenOptions)}
            getValue={getValue}
            updatePathogen={props.updatePathogen}
            handlePathogenBlur={props.handlePathogenBlur}
            handlePathogenSelect={props.handlePathogenSelect}
          />
      )})}

      {pathogenOtherSelections.map((pathogen, index) => {
        const option = {
          id: pathogen.id,
          displayName: 'Other',
          fieldName: 'pathogen_other_' + index,
          textFields: [
            {displayName: 'Name',
            fieldName: 'other_pathogen_description'}
          ],
          selectFields: [
            {displayName: 'Colony Count >105/ml?',
            fieldName: 'Other'}
          ]
        }

        return (
          <PathogenSelectionOption
            key={`pathogen-selection-option-${pathogenIdAndName}-${option.fieldName}`}
            option={option}
            pathogen={pathogen}
            optionIsSelected={true}
            site={site}
            disabled={props.disabled}
            primary_infection_sites={props.primary_infection_sites}
            required={getRequired(pathogenOptions)}
            getValue={getValue}
            updatePathogen={props.updatePathogen}
            handlePathogenBlur={props.handlePathogenBlur}
            handlePathogenSelect={props.handlePathogenSelect}
            handleNestedFieldClick={handleUpdateNestedFieldViaModal}
            preventChange
          />
      )})}

      {showCustomOptionModal ?
        <CustomCheckboxOptionModal
          show={showCustomOptionModal}
          modelName='Pathogen'
          onCancel={handleCancel}
          headerText="Add Other Pathogen"
          showAlertMessage={props.showWarning}
          toggleAlertMessage={(message) => props.setCustomPathogenWarning(message)}
          alertMessage={props.warningMessage}
          bodyText="Enter a name for the pathogen"
          formValue={pathogenToPatch ? pathogenToPatch.other_pathogen_description : ''}
          formPlaceholder="Enter name"
          onConfirm={(pathogenDescription) => handleOnConfirm(pathogenDescription)}
          onConfirmPatch={(updatedName) => handleOnConfirmPatch(updatedName)}
          onConfirmMethod={pathogenToPatch ? 'PATCH' : 'POST'}
          disabled={props.disabled}
        />
        :
        null
      }

      {site.displayPathogenQuestions ? 
        null
        :
        <>
          <br />
          <Button
            variant='secondary'
            onClick={() => setShowCustomOptionModal(true)}
          >
            Add Other Pathogen
          </Button>
          <br />
          <br />
        </>
      }

      <Button
        disabled={chartForReview}
        onClick={props.handleSavePathogensClick}
      >
        {site.displayPathogenQuestions ? "Edit Pathogens" : "Save Pathogens"}
      </Button>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    showWarning: state.infectionCourseFormReducer.showCustomPathogenWarning,
    warningMessage: state.infectionCourseFormReducer.customPathogenWarningMessage
  }
}

const mapDispatchToProps = {
  setCustomPathogenWarning,
}

export default connect(mapStateToProps, mapDispatchToProps)(PathogenSelection)




//logic to add colony count to pathogen if primary site is Respiratory
// {optionIsSelected && option.selectFields && option.selectFields.length > 0 && site.infection_site === 'Respiratory'?
//   <Fragment>
//     {option.selectFields.map(selectField => {
//       let pathogen =
//       site.pathogens.find(pathogen => pathogen.name === option.displayName)
//       let selected
//       pathogen.colony_count_greater_than_ten_to_the_fifth_power_per_ml === true ? selected = true : selected = false
//
//       return (
//         <Fragment>
//           <Row className="indented-row">
//             <Col xs={12} sm={12} md={6} lg={6}>
//               <Form.Label>
//                 {selectField.displayName}
//               </Form.Label>
//             </Col>
//           </Row>
//           <Row className="indented-row">
//             <Col xs={12} sm={12} md={6} lg={6}>
//             <Form.Check
//               name={'colony_count_greater_than_ten_to_the_fifth_power_per_ml'}
//               label={'Yes'}
//               value={selected}
//               onChange={(e, option, site) => handlePathogenCheckboxFieldChange(e, selectField.fieldName, props.site)}
//               disabled={site.displayPathogenQuestions || chartForReview ? true : false}
//               onBlur={handlePathogenBlur}
//
//             />
//             </Col>
//           </Row>
//         </Fragment>
//       )
//     })}
//   </Fragment>
//   :
//   null}
